import { createFileRoute, redirect, useNavigate } from "@tanstack/react-router";
import { LocationEdit } from "@/features/catalog";

export const Route = createFileRoute("/catalog/locations/new")({
  beforeLoad: ({ context }) => {
    if (!context.permissions.canWrite("Location")) {
      throw redirect({ to: "/catalog/locations" });
    }
  },
  component: NewLocationComponent,
});

function NewLocationComponent() {
  const navigate = useNavigate();
  const backToLocations = () => navigate({ to: "/catalog/locations" });

  return <LocationEdit canEdit onDone={backToLocations} onCancel={backToLocations} />;
}
